<template>
    <div class="px-2">
      <v-btn small class="" @click="$router.back()" color="info" square outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras </v-btn>
      <h4 class="text-center mt-0 mb-0 pb-0"> Reporte de envios a Netsuite </h4>
      <p class="text-center py-0 mt-0 mb-5"> <small> {{ filtros.sede_id?filtros.sede_id.text:'' }} </small> </p>
      <!-- <v-divider class="my-0" /> -->

      <div class="row">
        <div class="col-xs-12 col-sm-3 mb-0 pb-0">
            <v-select :items="meses" v-model="filtros.mes" dense label="Mes:" outlined return-object></v-select>
        </div>
        <div class="col-xs-12 col-sm-3 mb-0 pb-0">
            <v-select :items="gestiones" v-model="filtros.anio" dense label="Gestion:" outlined return-object></v-select>
        </div>
        <div class="col-xs-12 col-sm-3 mb-0 pb-0" v-if="$store.state.CARGO.id==14 || $store.state.CARGO.id==1"> 
            <v-select :items="sedes" v-model="filtros.sede_id" dense label="Sede:" outlined clearable return-object></v-select>
        </div>
        <div class="col-xs-12 col-sm-3 mb-0 pb-0">
            <v-checkbox v-model="filtros.is_agrupado" label="Agrupado" dense />
        </div> 
    </div>
    <div class="row no-gutters">
        <div class="col-xs-12 col-sm-3 mt-0 pt-0">
            <v-btn text dense outlined :loading="loading" color="blue" @click="listar()"> consultar </v-btn>
        </div> 
    </div>

      <div class="row">
        <div class="col-xs-12">
            <v-data-table :loading="loading" :headers="dessertHeaders" :items="desserts" :single-expand="singleExpand" :expanded.sync="expanded" item-key="xid" disable-pagination hide-default-footer dense :show-expand="filtros.is_agrupado" class="elevation-1" >
                <template v-slot:[`item.porcentaje_avance`]="{ item }">
                    <span> {{ item.porcentaje_avance }} % </span>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                        <v-data-table
                            :headers="headersDeta"
                            :items="item.detalle"
                            disable-pagination hide-default-footer dense
                            class="elevation-1 ml-8 my-3">
                            <template v-slot:[`item.porcentaje_avance`]="{ item }">
                                <span> {{ item.porcentaje_avance }} % </span>
                            </template>
                        </v-data-table>
                    </td>
                </template>
            </v-data-table>
        </div>
      </div>

    </div>
  </template>
  
  <script>
  import {getMeses,getGestiones,getSedes,getDatos} from './meses'
  
  export default {
    data(){
      return{
        meses: [],
        gestiones:[],
        sedes: [],
        loading: false,
        singleExpand: false,
        expanded: [],
        filtros:{
            mes:null,
            anio: null,
            is_agrupado: false,
            sede_id: null,
        }, 
        headersDeta:[
            {text: 'Empleado', value: 'nombre_empleado'},
            {text: 'Porcentaje', value: 'porcentaje_avance'},
            {text: 'Recibos generados', value: 'cantidad_recibos_generados'},
            {text: 'Recibos enviados', value: 'cantidad_recibos_enviados_netsuite'},
            {text: 'Recibos faltantes', value: 'cantidad_recibos_faltantes_netsuite'},
        ],
        desserts:[],
      }
    },
    components:{  },
    computed:{
        dessertHeaders() {
            const h = [
                { text: 'Sede', value: 'nombre_sede' },
                { text: '% avance', value: 'porcentaje_avance' },
                { text: 'Recibos generados', value: 'cantidad_recibos_generados' },
                { text: 'Recibos faltantes', value: 'cantidad_recibos_faltantes_netsuite' },
                { text: 'Recibos enviados', value: 'cantidad_recibos_enviados_netsuite' },
            ]
            if(!this.filtros.is_agrupado){ 
                h.splice(1,0,{ text: 'Empleado', value: 'nombre_empleado' })
            }
            return h
        }
    },
    watch:{
        'filtros.is_agrupado': function(){
            this.listar();
        },
        '$store.state.CARGO'(){
            if(!this.$store.state.CARGO) return;
            let buscar = this.sedes.find(x=>x.id==this.$store.state.CARGO.idsede);
            this.filtros.sede_id = buscar;
            this.listar();
        }
    },
    methods:{
        async iniciar(){
            this.loading = true;
            this.filtros.mes = null;
            this.filtros.anio = null;
            const r1 = getMeses();
            const r2 = await getGestiones(this);
            const r3 = await getSedes(this);
            window.console.log('sedessss', r3);
            this.meses = r1.meses
            this.gestiones = r2.gestiones;
            this.sedes = r3.sedes;
            this.filtros.mes = r1.actual;
            this.filtros.anio = r2.actual;
            this.filtros.sede_id = r3.actual;
            this.loading = false;
        },
        async listar(){
            this.desserts = [];
            this.loading = true;
            let url = process.env.VUE_APP_API_REST+'/api/v1/esam/reporteenvionetsuite'
            url += `?mes=${this.filtros.mes.id}&anio=${this.filtros.anio.id}`
            url += `&is_agrupado=${this.filtros.is_agrupado}`
            if(this.filtros.sede_id) url += `&sede_id=${this.filtros.sede_id.id}`
            const res = await getDatos(url);
            this.parseData(res);
            this.loading = false;
        },
        parseData(data){
            window.console.log('data',data);
            this.desserts = data;
        },

    },
    async mounted(){
      await this.iniciar();
      this.listar();
    }
    
  }
  </script>